'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const utils_clamp = require('../../../utils/clamp.cjs.js');
const utils_headingLevelContext_HeadingLevelContext = require('../../../utils/heading-level-context/HeadingLevelContext.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const HeadingLevel = ({ children }) => {
  const { level } = utils_headingLevelContext_HeadingLevelContext.useHeadingLevel();
  const nextLevel = utils_clamp.clamp(level + 1, 1, 6);
  return React__default.default.createElement(utils_headingLevelContext_HeadingLevelContext.HeadingLevelProvider, { level: nextLevel }, children);
};

exports.HeadingLevel = HeadingLevel;
//# sourceMappingURL=HeadingLevel.cjs.js.map
